module.exports = "/images/morning-balitaktakan.png?35f3a0efb7ec99fc9a950d1b336a27cb";